import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { MoreVertical, Ban, CheckCircle } from "lucide-react";

export interface FormStats {
  id: string;
  title: string;
  slug: string;
  is_active: boolean;
  owner_email: string;
  sessions_count: number;
  completed_count: number;
  pdf_downloads: number;
}

interface Props {
  forms: FormStats[];
  onToggleActive: (formId: string, currentActive: boolean) => void;
}

export default function FormsTab({ forms, onToggleActive }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Todos os Formulários</CardTitle>
        <CardDescription>Visualize e gerencie todos os formulários</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Título</TableHead>
              <TableHead>Dono</TableHead>
              <TableHead>Status</TableHead>
              <TableHead className="text-right">Leads</TableHead>
              <TableHead className="text-right">Completados</TableHead>
              <TableHead className="text-right">PDFs</TableHead>
              <TableHead className="w-[50px]"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {forms.map((form) => (
              <TableRow key={form.id}>
                <TableCell>
                  <div>
                    <div className="font-medium">{form.title}</div>
                    <div className="text-sm text-muted-foreground">/f/{form.slug}</div>
                  </div>
                </TableCell>
                <TableCell className="text-muted-foreground">{form.owner_email}</TableCell>
                <TableCell>
                  <Badge variant={form.is_active ? "default" : "secondary"}>
                    {form.is_active ? "Ativo" : "Bloqueado"}
                  </Badge>
                </TableCell>
                <TableCell className="text-right">{form.sessions_count}</TableCell>
                <TableCell className="text-right">{form.completed_count}</TableCell>
                <TableCell className="text-right">{form.pdf_downloads}</TableCell>
                <TableCell>
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="ghost" size="icon" className="h-8 w-8">
                        <MoreVertical className="h-4 w-4" />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end">
                      <DropdownMenuItem onClick={() => onToggleActive(form.id, form.is_active)}>
                        {form.is_active ? (
                          <>
                            <Ban className="mr-2 h-4 w-4 text-destructive" />
                            Bloquear
                          </>
                        ) : (
                          <>
                            <CheckCircle className="mr-2 h-4 w-4 text-success" />
                            Ativar
                          </>
                        )}
                      </DropdownMenuItem>
                      <DropdownMenuItem asChild>
                        <a href={`/f/${form.slug}`} target="_blank" rel="noopener noreferrer">
                          Visualizar
                        </a>
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
